<template>
  <v-card>
    <v-card-title>{{ $t('races.title') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.items"
        hide-default-headers
        hide-default-footer
        disable-pagination
        disable-sort
      >
        <template v-slot:item.totalTime="{item}">
          <span v-if="item.disqualification">DSQ</span>
          <span v-else>
            <div v-if="item.disqualification">DSQ</div>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{item.totalTime | runTime}}</span>
              </template>
              <span>{{item.time | runTime}} + {{ item.additionalTime | seconds }} s</span>
            </v-tooltip>
          </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
  } from 'vuetify/lib'
  import fccapi from '../../fccapi'

  export default {
    name: 'FCCApplicationRuns',
    filters: {
      runTime: function(t) {
        var r = new RegExp("\\d{2}:(\\d{2}:(\\d{2}(\\.\\d{2})?))", "g");
        var result = r.exec(t);
        if (!result) return "";
        return result[1].trimLeft();
      },
      seconds: function(t) {
        var r = new RegExp("\\d{2}:(\\d{2}):(\\d{2}(\\.\\d{2})?)", "g");
        var result = r.exec(t);
        if (!result) return "";
        return parseInt(result[1]) * 60 + parseFloat(result[2]);
      }
    },
    data: function(){
        return {
            items: [],
        }
    },
    methods: {
        reload: function(){
            fccapi.get(`applications/${this.$route.params.id}/runs`).then(d=>{
                this.items = d.data
            })
        },
    },
    props: {
      data: Object
    },
    computed: {
      headers: function(){
        return [
          { text: this.$t('races.race'), value: 'race.name', align: 'left' },
          { text: this.$t('runs.startNumber'), value: 'startNumber', align: 'left' },
          { text: this.$t('runs.totalTime'), value: 'totalTime', align: 'left' },
        ];
      }
    },
    mounted: function(){
        console.log("mounted")
        this.reload();
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable
    }
  }
</script>